export const PageSizes = [
    //A4
    {
        width: 210,
        height: 297
    },
    //A3
    {
        width: 297,
        height: 420
    },
    //Letter
    {
        width: 215.9,
        height: 279.4
    }
];